'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  FRIENDS_TAB_COUNTS_QUERY_KEY,
  RECEIVED_REQUESTS_QUERY_KEY,
} from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { declineFriendRequest } from '@/utils/actions/players/friends/declineFriendRequest';

export interface UseDeclineFriendRequestParams {
  uuid: string;
  friendUuid: string;
}

export const useDeclineFriendRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, friendUuid }: UseDeclineFriendRequestParams) => {
      const res = await declineFriendRequest({ uuid, friendUuid });
      if (res.error) {
        throw new Error(`Failed to decline friend request: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RECEIVED_REQUESTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
    },
  });
};
